var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "el-dialog",
    {
      attrs: {
        visible: _vm.dialogVisible,
        title: "导入模板",
        width: "55%",
        "append-to-body": true,
        "modal-append-to-body": true,
      },
      on: {
        "update:visible": function ($event) {
          _vm.dialogVisible = $event
        },
        close: _vm.handleClose,
      },
    },
    [
      _c(
        "div",
        { staticClass: "header-tabs" },
        [
          _c(
            "el-tabs",
            {
              on: { "tab-click": _vm.handleTabClick },
              model: {
                value: _vm.activeTab,
                callback: function ($$v) {
                  _vm.activeTab = $$v
                },
                expression: "activeTab",
              },
            },
            [
              _c("el-tab-pane", {
                attrs: { label: "本酒店", name: "current" },
              }),
              _c("el-tab-pane", {
                attrs: { label: "其他酒店", name: "other" },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "table-container" },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              ref: "templateTable",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData,
                "highlight-current-row": "",
                border: "",
              },
              on: {
                "current-change": _vm.handleCurrentChange,
                "row-click": _vm.handleRowClick,
              },
            },
            [
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "id",
                  label: "模板id",
                  "min-width": "200",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticClass: "template-id-cell",
                            class: {
                              selected:
                                _vm.selectedTemplate &&
                                _vm.selectedTemplate.id === scope.row.id,
                            },
                          },
                          [
                            _c("span", { staticClass: "id-text" }, [
                              _vm._v(_vm._s(scope.row.id)),
                            ]),
                            _vm.selectedTemplate &&
                            _vm.selectedTemplate.id === scope.row.id
                              ? _c(
                                  "el-tag",
                                  {
                                    staticClass: "selected-tag",
                                    attrs: { type: "success", size: "mini" },
                                  },
                                  [_vm._v(" 选中 ")]
                                )
                              : _vm._e(),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "resourceName",
                  label: "酒店名称",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "productName",
                  label: "产品名称",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "createTime",
                  label: "创建时间",
                  "min-width": "120",
                  formatter: _vm.formatDate,
                },
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text", size: "small" },
                            on: {
                              click: function ($event) {
                                return _vm.previewTemplate(scope.row)
                              },
                            },
                          },
                          [_vm._v(" 预览 ")]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "pagination-container" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.requestParameters.page,
                  "page-sizes": [10, 20, 50, 100],
                  "page-size": _vm.requestParameters.size,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handlePageChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        {
          staticClass: "dialog-footer",
          attrs: { slot: "footer" },
          slot: "footer",
        },
        [
          _c("el-button", { on: { click: _vm.handleClose } }, [_vm._v("取消")]),
          _c(
            "el-button",
            {
              attrs: { type: "primary", disabled: !_vm.selectedTemplate },
              on: { click: _vm.handleConfirm },
            },
            [_vm._v(" 确定 ")]
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            visible: _vm.previewVisible,
            title: "模板预览",
            width: "60%",
            "append-to-body": true,
          },
          on: {
            "update:visible": function ($event) {
              _vm.previewVisible = $event
            },
          },
        },
        [
          _c("div", {
            staticClass: "preview-content",
            domProps: { innerHTML: _vm._s(_vm.previewContent) },
          }),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                {
                  on: {
                    click: function ($event) {
                      _vm.previewVisible = false
                    },
                  },
                },
                [_vm._v("关闭")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }